const qaItems = [
  {
    q: "What vehicle storage services does Don Collins Auto Storage offer?",
    a: "Don Collins Auto Storage offers fully-alarmed indoor storage for automobiles, classic and collector cars, motorcycles, RVs, motorhomes, boats, trucks, and specialty equipment. All storage is indoors at two secure Bay Area facilities in San Rafael and Point Richmond, CA.",
  },
  {
    q: "What types of vehicles can be stored at Don Collins?",
    a: "We store virtually every vehicle type — passenger cars, classic and collector automobiles, motorcycles, RVs, boats, trucks, and commercial equipment. Contact us to confirm space availability for oversized or specialty vehicles.",
  },
  {
    q: "How does the indoor storage process work at Don Collins?",
    a: "Storage is by appointment. Call first to confirm current availability, select your storage duration, coordinate a drop-off time, and your vehicle is secured in our fully-alarmed indoor facility. Motorcycle transport is available if needed for drop-off.",
  },
  {
    q: "What makes indoor storage better than outdoor storage?",
    a: "Indoor storage fully protects vehicles from UV damage, humidity, rain, temperature swings, and theft — all common risks with outdoor storage. For collectors and high-value vehicles, indoor protection is essential for maintaining condition and resale value.",
  },
];

export default function ServicesAIAnswerBlock() {
  return (
    <section
      id="about"
      className="bg-white py-24 lg:py-32"
      itemScope
      itemType="https://schema.org/FAQPage"
    >
      <div className="max-w-4xl mx-auto px-6 lg:px-10">
        <div className="flex items-start gap-5 mb-14">
          <div className="w-12 h-12 flex items-center justify-center bg-gold rounded-full flex-shrink-0 mt-1">
            <i className="ri-robot-2-line text-charcoal text-xl"></i>
          </div>
          <div>
            <p className="font-sans text-gold text-xs tracking-[0.3em] uppercase font-semibold mb-2">
              Service Overview
            </p>
            <h2 className="font-serif text-charcoal text-3xl lg:text-4xl font-bold">
              Storage Services, Answered
            </h2>
          </div>
        </div>

        <div className="space-y-0">
          {qaItems.map((item, idx) => (
            <div
              key={idx}
              className="border-b border-[#EBEBEB] py-8"
              itemScope
              itemProp="mainEntity"
              itemType="https://schema.org/Question"
            >
              <h3
                className="font-serif text-charcoal text-xl font-semibold mb-3"
                itemProp="name"
              >
                {item.q}
              </h3>
              <div
                itemScope
                itemProp="acceptedAnswer"
                itemType="https://schema.org/Answer"
              >
                <p
                  className="font-sans text-[#555] text-base leading-relaxed"
                  itemProp="text"
                >
                  {item.a}
                </p>
              </div>
            </div>
          ))}
        </div>

        <div className="mt-10 flex items-center gap-4">
          <div className="w-1 h-12 bg-gold rounded-full flex-shrink-0"></div>
          <p className="font-sans text-[#555] text-sm leading-relaxed italic">
            "Secure, fully-alarmed indoor storage for motor vehicles — best rates for long-term storage."
            <span className="block text-charcoal font-medium mt-1 not-italic">— Don Collins Auto Storage</span>
          </p>
        </div>
      </div>
    </section>
  );
}
